<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_confirm">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ data.title }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="cancel"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <div>{{ data.desc }}</div>
            </div>
            <div class="lite_popup_footer">
                <!-- 取消按钮 -->
                <button v-if="showCancel" class="white" @click="cancel">{{ localCancelText }}</button>
                <!-- 确定按钮 -->
                <button ref="okBtn" @keyup.esc="cancel" @keyup.enter="ok" @click="ok">
                    <i v-if="loading" class="el-icon-loading" style="color:#fff;"></i>
                    <span>{{ localOkText }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showCancel: { type: Boolean, default: false },
        autoClose: { type: Boolean, default: true },
        okText: { type: String, default: 'OK' },
        cancelText: { type: String, default: 'Cancel' },
        data: {
            title: { type: String, default: 'Title' },
            desc: { type: String, default: 'Description content' },
        }
    },
    data() {
        return {
            show: false,
            loading: false,
        };
    },
    computed: {
        localOkText() {
            return this.okText === 'OK' ? this.$t('language.common.ok') : this.okText;
        },
        localCancelText() {
            return this.cancelText === 'Cancel' ? this.$t('language.common.cancel') : this.cancelText;
        },
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            if (this.loading) return;
            if (this.autoClose) {
                this.show = false;
            }
            this.$emit('ok');
        },
        cancel() {
            if (this.loading) return;
            this.show = false
            this.$emit('cancel');
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_confirm {
    width: 620px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_confirm.vue